import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductHowItWorksTab } from './product-how-it-works.interface';

@Component({
  selector: 'app-product-how-it-works',
  templateUrl: './product-how-it-works.component.html',
  styleUrls: ['./product-how-it-works.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductHowItWorksComponent {
  private readonly DEFAULT_HEADING_ID = 'product-how-it-works-heading';
  private _activeTabId = '';

  @Input() headline = '';
  @Input() headingId = '';
  @Input() tabs: ProductHowItWorksTab[] = [];

  @Input() set activeTabId(value: string) {
    this._activeTabId = value;
  }
  get activeTabId(): string {
    return this._activeTabId;
  }

  @Output() activeTabIdChange = new EventEmitter<string>();

  get resolvedHeadingId(): string {
    const id = this.headingId.trim();
    return id || this.DEFAULT_HEADING_ID;
  }

  get hasTabs(): boolean {
    return this.tabs.length > 0;
  }

  get activeTab(): ProductHowItWorksTab | undefined {
    return this.tabs.find((tab) => tab.id === this._activeTabId) || this.tabs[0];
  }

  onTabChange(tabId: string): void {
    if (tabId === this._activeTabId) {
      return;
    }
    this._activeTabId = tabId;
    this.activeTabIdChange.emit(tabId);
  }

  trackByTabId(_index: number, tab: ProductHowItWorksTab): string {
    return tab.id;
  }

  trackByCardIndex(index: number): number {
    return index;
  }
}
